import { SvgIcon, type SvgIconProps } from '../layout/SvgIcon';

export const CircledQuestionIcon24: React.FC<SvgIconProps> = (props) => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.444 16.669a1 1 0 1 1 1.111 1.662 1 1 0 0 1-1.11-1.662Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.5 12a9.5 9.5 0 1 0 19 0 9.5 9.5 0 0 0-19 0Zm1.722 7.778A11 11 0 1 1 19.778 4.222 11 11 0 0 1 4.222 19.778Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 7.25A2.25 2.25 0 0 0 9.75 9.5a.75.75 0 0 1-1.5 0 3.75 3.75 0 1 1 4.977 3.544.92.92 0 0 0-.375.237c-.081.09-.102.163-.102.219v1a.75.75 0 0 1-1.5 0v-1c0-1.002.808-1.638 1.486-1.873A2.251 2.251 0 0 0 12 7.25Z"
        />
    </SvgIcon>
);
